import { useState, useEffect } from 'react'

import { adminFamilyGroupService } from '../services/adminFamilyGroup.services'

const useAdminFamilyGroup = (patientId: number) => {
  const [data, setData] = useState<any[] | null>(null)
  const [familyGroupsAsMember, setFamilyGroupsAsMember] = useState<any[] | null>(null)

  useEffect(() => {
    getFamilyGroupsAsMember()
  }, [])

  useEffect(() => {
    getFamilies()
  }, [])

  const getFamilies = async () => {
    const resp = await adminFamilyGroupService.getFamilies(patientId)
    console.log('getFamilies', resp)
    setData(resp.data && resp.data.families ? resp.data.families : [])
  }

  const getFamilyGroupsAsMember = async () => {
    const resp = await adminFamilyGroupService.getFamilyGroupsAsMember(patientId)
    console.log('getFamilyGroupsAsMember', resp)
    setFamilyGroupsAsMember(resp.data && resp.data.familyGroups ? resp.data.familyGroups : [])
  }

  const deleteFamilyGroup = async (id: number) => {
    const resp = await adminFamilyGroupService.delFamilyGroup(id)
    if (resp.status === 'Ok') {
      await getFamilies()
      await getFamilyGroupsAsMember()
    }
    return resp
  }

  return {
    data,
    familyGroupsAsMember,
    getFamilies,
    getFamilyGroupsAsMember,
    deleteFamilyGroup
  }
}

export { useAdminFamilyGroup }